<upp-kb-input #input
    type="text"
    [kiosk]="kiosk"
    [formControl]="Control"
    [name]="name"
    [placeholder]="content"
    [readonly]="readonly"
></upp-kb-input>
